export default __webpack_public_path__ + "static/media/circle_tip_icon.28061065.svg";